import { LatLngAlt } from "../../../types.js";

export const edgeNeokyoA1: LatLngAlt[] = [
  [-10.783649, 165.838226, 65.8],
  [-10.783765, 165.838248, 65.8],
  [-10.783871, 165.838312, 65.8],
  [-10.783945, 165.838398, 65.8],
  [-10.783988, 165.838505, 65.8],
];
export const edgeNeokyoA2: LatLngAlt[] = [
  [-10.783955, 165.838505, 65.8],
  [-10.783984, 165.838333, 65.8],
  [-10.784072, 165.838205, 65.8],
];
export const edgeNeokyoA3: LatLngAlt[] = [
  [-10.784025, 165.838205, 65.8],
  [-10.783862, 165.838226, 65.8],
  [-10.783697, 165.838248, 65.8],
];
